export function getCurrencySymbolByCurrencyId(currencyId:number) {
    switch (currencyId) {
        case 1:
        case 949:
            return "₺";
        case 2:
        case 978:
            return "€";
        case 3:
        case 840:
            return "$";    
        default:
            return "₺";
    }
}